import { Brand, VehicleTileData } from '@sccs/types';
import { TCampaignTileAemPayload } from '../../schema/campaign-tile/CampaignTileData';
import { VehicleDls } from '../../schema/dls/DeepLinkingSearchResults';
import { Vehicle } from '../one-search/queries';

export enum RawDataSchema {
  ONE_SEARCH = 'OneSearch',
  DLS = 'DLS',
  T4_PERSONALIZATION = 'T4',
  CAMPAIGN_TILE = 'CampaignTile',
  VEHICLE_TILE_DATA = 'VehicleTileData',
}

export type RequestParamsRawData = {
  rawData: { schema: RawDataSchema; data: unknown };
  market: string;
  lang: string;
  brand?: Brand;
};

export type RawVehicleTileData = {
  data: VehicleTileData;
  schema: RawDataSchema.VEHICLE_TILE_DATA;
};

export type RawDlsData = {
  data: VehicleDls;
  schema: RawDataSchema.DLS;
};

export type RawT4Data = {
  data: VehicleDls;
  schema: RawDataSchema.T4_PERSONALIZATION;
};

export type RawCampaignTileData = {
  data: TCampaignTileAemPayload;
  schema: RawDataSchema.CAMPAIGN_TILE;
};

export type RawOneSearchData = {
  data: Vehicle;
  schema: RawDataSchema.ONE_SEARCH;
};

export type RawData = RawVehicleTileData | RawDlsData | RawT4Data | RawCampaignTileData | RawOneSearchData;
